var Qawafil = (function () {
    'use strict';
    var QAWAFIL_DEFAULT_LOCALE = 'ar';
    var CUSTOMER_ID_SELECTOR = 'meta[name="customer"]';
    var SESSION_TOKEN_SELECTOR = 'meta[name="csrf-token"]';


    var shopApiEndpoint = null;
    var shopEndpoint = null;
    var shopBaseUrl = null;
    var isRtlDir = true;
    var sessionAuthNeeded = true; // todo: update code to check this
    var config = {} // todo: shop (including shop_url) , dir (rtl, ltr), locale, sessionAuthNeeded

    function setShopUrl(shopUrl) {
        shopBaseUrl = shopUrl;
        shopEndpoint = shopUrl;
        shopApiEndpoint = shopUrl + '/api/storefront';
    }

    function getShopUrl() {
        return shopBaseUrl;
    }
    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    function getMetaContent(name) {
        const tag = document.querySelector(`meta[name="${name}"]`);
        return tag ? tag.getAttribute('content') : null;
    }

    var DOMHelpers = {
        getCustomerIdMetaTag : function (){
            return document.querySelector(CUSTOMER_ID_SELECTOR);
        },
        getAuthSessionTokenMetaTag : function (){
            return document.querySelector(SESSION_TOKEN_SELECTOR);
        }
    }

    var LocalizationHelpers = {
        setIsRtl: function (isRtl) {
            isRtlDir = isRtl;
        },
        isRtl: function () {
            return isRtlDir;
        },

        getLocale: function () {
            return localStorage.getItem('locale') || QAWAFIL_DEFAULT_LOCALE
        },

        setLocale: function (locale) {
            return localStorage.setItem('locale', locale);
        }
    }

    var AuthHelpers = {
        // private helpers
        getAuthSessionCustomerId: function () {
            var customerMetaTag = DOMHelpers.getCustomerIdMetaTag();
            return customerMetaTag ? customerMetaTag.content : null
        },

        getAuthSessionToken: function () {
            var sessionTokenMetaTag = DOMHelpers.getAuthSessionTokenMetaTag();
            return sessionTokenMetaTag ? sessionTokenMetaTag.content : null
        },

        hasAuthSession: function () {
            var customerId = AuthHelpers.getAuthSessionCustomerId();
            return customerId !== null && customerId !== '' && customerId !== undefined;
        },

        getApiAuthToken: function () {
            return localStorage.getItem('access_token');
        },

        hasApiAuthToken: function () {
            return AuthHelpers.getApiAuthToken() !== null;
        },

        resetApiAuth: function () {
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
        },

        setApiAuthToken: function (accessToken) {
            localStorage.setItem('access_token', accessToken);
        },

        setApiRefreshToken: function (refreshToken) {
            localStorage.setItem('refresh_token', refreshToken);
        },



    }

    var APIHelpers = {

        sendApiRequest: function (settings) {
            var defaultRequestOptions = {
                headers: {
                    'Accept': 'application/json',
                    'Accept-Language': LocalizationHelpers.getLocale(),
                    'Authorization': 'Bearer ' + AuthHelpers.getApiAuthToken(),
                    'X-Storefront-Token': getMetaContent('sf-token')
                },
                credentials: 'include'
            };
            var afterResponseCallback = config.api && typeof config.api.afterResponse === 'function' ? config.api.afterResponse : null;

            var requestFetch = function () {

                if (config.api && typeof config.api.beforeSend === 'function') {
                    config.api.beforeSend();
                }
                // blockPage();
                console.log('** beforeSend request fetch **');
                return fetch.apply(this, arguments);
            };

            var options = {};

            if (settings.requestOptions) {
                options = Object.assign({}, defaultRequestOptions, settings.requestOptions);
            }

            if (settings.sendAsFormData !== true) {
                options.headers['Content-Type'] = 'application/json';
            }

            if (settings.callback === null) {
                settings.callback = function (response) {};
            }

            requestFetch(settings.url, options)
                .then(response => response.json())
                .then(response => {
                    // if(settings.showResponseMsg === false) response.message = null;
                    if(afterResponseCallback) afterResponseCallback(response);
                    // $.unblockUI();
                    if (!response.status) {
                        console.error(response);
                        if (response.code === 403) {
                            // if storefront token expired
                            location.reload();
                        }
                        if (response.code === 401) {
                            // todo: must be improved later to refresh token using current access token
                            if (AuthHelpers.hasAuthSession()) {
                                AuthHelpers.resetApiAuth();
                                // todo: can improve by sending event to display message
                                // toastError("انتهت الجلسة الحالية")
                                location.reload();
                            } else {
                                AuthHelpers.resetApiAuth();
                                // todo: send event AuthRequired
                                events.privateFunctions.dispatchNewEvent(events.list.auth.AuthRequired, response)
                            }
                        } /*else {
                            if (response.message && settings.showResponseMsg !== false) toastError(response.message);
                        }*/
                    } /*else {
                        if (response.message && settings.showResponseMsg !== false) toastSuccess(response.message);
                        // TODO: any implementation here ..
                    }*/
                    if (typeof settings.callback === 'function' && response) {
                        settings.callback(response);
                    }
                }).catch(err => {
                    console.error('sendApiRequestError', err);
                    if(afterResponseCallback) afterResponseCallback(err);
                    if (typeof settings.callback === 'function') {
                        settings.callback(null);
                    }
                    // if (settings.showResponseMsg !== false) toastError("حدث خطأ في العملية");
                });
        },
        jsonBody: function (body) {
            return JSON.stringify(body);
        },
        getShopAPIEndpoint: function () {
            return shopApiEndpoint;
        }
    }

    var events = {
        list: {
            auth: {
                AuthRequired: "AuthRequired",
                SendingCodeSucceeded: "SendingCodeSucceeded",
                SendingCodeFailed: "SendingCodeFailed",
                VerificationSucceeded: "VerificationSucceeded",
                VerificationFailed: "VerificationFailed",  /* causes: wrong auth details | error in sending the code itself */
                RegistrationSucceeded: "RegistrationSucceeded",
                RegistrationFailed: "RegistrationFailed",
            }


        },
        privateFunctions: {
            dispatchNewEvent: function (type, details){
                document.dispatchEvent(new CustomEvent(type, {"details": details}));
            }
        },
        publicFunctions:{
            on: function (eventType, handler){
                document.addEventListener(eventType, function (e){
                    handler(e.details)
                });
            },
            onAuthRequired: function (handler){
                Qawafil.events.on(events.list.auth.AuthRequired, handler);
            }
        }

    }

    var auth = {

        privateFunctions: {

        },

        publicFunctions: {
            /**
             * @param {Object} data - The data object containing login details.
             * @param {string} data.verify_via - The type of verification being used, either 'mobile_sms', 'mobile_whatsapp' or 'email'.
             * @param {string|null} data.email - The email address if verify_via is 'email', otherwise null.
             * @param {string|null} data.mobile - The mobile number if verify_via is 'mobile_sms', 'mobile_whatsapp', otherwise null.
             */
            login: function (data, callback) {
                // events => [
                //     "SendingCodeSucceeded",
                //     "SendingCodeFailed"  /*causes: wrong auth details | error in sending the code itself */
                // ]

                return APIHelpers.sendApiRequest({
                    url: shopApiEndpoint + '/auth/login',
                    requestOptions: {
                        method: 'POST',
                        body: APIHelpers.jsonBody(data)
                    },
                    callback: callback
                });
            },

            /**
             * @param {Object} data - The data object containing login details.
             * @param {string} data.verify_via - The type of verification being used, either 'mobile_sms', 'mobile_whatsapp' or 'email'.
             * @param {string|null} data.email - The email address if verify_via is 'email', otherwise null.
             * @param {string|null} data.mobile - The mobile number if verify_via is 'mobile_sms', 'mobile_whatsapp', otherwise null.
             */
            resendCode: function (data, callback) {
                // same as login
                auth.login(data, callback);
            },

            /**
             * @param {Object} data - The data object containing login details.
             * @param {string} data.code - The code to be verified.
             * @param {string} data.verify_via - The type of verification being used, either 'mobile_sms', 'mobile_whatsapp' or 'email'.
             * @param {string|null} data.email - The email address if verify_via is 'email', otherwise null.
             * @param {string|null} data.mobile - The mobile number if verify_via is 'mobile_sms', 'mobile_whatsapp', otherwise null.
             */
            verifyOTP: function (data, callback) {
                //  events => [
                //     "onVerificationSucceeded",
                //     "onVerificationFailed"  /* causes: wrong auth details | error in sending the code itself */
                // ]


                APIHelpers.sendApiRequest({
                    url: shopApiEndpoint + '/auth/verify',
                    requestOptions: {
                        method: 'POST',
                        body: APIHelpers.jsonBody(data)
                    },
                    callback: callback,
                    showResponseMsg: false
                });
            },

            /**
             * @param {Object} userData - The object containing user registration information.
             * @param {string} userData.verified_via - The method used to verify the user's identity in the verification step,
             *                                          which can be either 'email' or 'mobile'.
             * @param {string} userData.registration_code - The registration code returned from the verification step for new customer.
             * @param {string} userData.email - The user's email address.
             * @param {string} userData.mobile - The user's mobile number.
             * @param {string} userData.first_name - The user's first name, retrieved from the registration form.
             * @param {string} userData.last_name - The user's last name, retrieved from the registration form.
             */
            register: function (data, callback) {
                //  events => [
                //     "onRegistrationSucceeded",
                //     "onRegistrationFailed"
                // ]

                APIHelpers.sendApiRequest({
                    url: shopApiEndpoint + '/auth/register',
                    requestOptions: {
                        method: 'POST',
                        body: APIHelpers.jsonBody(data)
                    },
                    callback: callback,
                    showResponseMsg: false
                });
            },

            logout: function (callback) {
                APIHelpers.sendApiRequest({
                    url: shopApiEndpoint + '/logout',
                    requestOptions: {
                        method: 'POST'
                    },
                    callback: callback
                });
            }
        }



    };

    var cart = {

        init: function(){

        },
        getCart: function(callback = null){
            APIHelpers.sendApiRequest({
                url: shopApiEndpoint + '/cart/get',
                requestOptions: {
                    method: 'GET',
                },
                callback: callback
            });
        },
        addToCart: function(formData, callback) {

            APIHelpers.sendApiRequest({
                url: shopApiEndpoint + '/cart/add',
                requestOptions: {
                    method: 'POST',
                    body: formData
                },
                callback: callback,
                sendAsFormData: true

            });
        },
        updateItemQuantity: function(itemId, quantity, callback) {
            APIHelpers.sendApiRequest({
                url: shopApiEndpoint + '/cart/update-quantity',
                requestOptions: {
                    method: 'POST',
                    body: APIHelpers.jsonBody({
                        item_id: itemId,
                        quantity: quantity
                    })
                },
                callback: callback
            });
        },
        deleteItem: function(itemId, callback) {
            APIHelpers.sendApiRequest({
                url: shopApiEndpoint + '/cart/delete/' + itemId,
                requestOptions: {
                    method: 'DELETE'
                },
                callback: callback
            });
        },
        clearCart: function(callback){
            APIHelpers.sendApiRequest({
                url: shopApiEndpoint + '/cart/clear',
                requestOptions: {
                    method: 'DELETE'
                },
                callback: callback
            });
        }

    };

    var customer = {

        // ==================== Qawafil.customer.address ===============================================
        address: {
            getAddress: function(addressId, callback) {
                APIHelpers.sendApiRequest({
                    url: shopApiEndpoint + '/user/address/' + addressId,
                    requestOptions: {
                        method: 'GET',
                    },
                    callback: callback
                });
            },
            getAddressesList: function(callback = null) {
                APIHelpers.sendApiRequest({
                    url: shopApiEndpoint + '/user/address',
                    requestOptions: {
                        method: 'GET',
                    },
                    callback: callback
                });
            },
            saveAddress: function(addressData, addressId, callback) {
                let url = '';

                if (addressId)
                    url = shopApiEndpoint + '/user/address/'+ addressId +'/update';
                else
                    url = shopApiEndpoint + '/user/address/store';

                APIHelpers.sendApiRequest({
                    url: url,
                    requestOptions: {
                        method: 'POST',
                        body: APIHelpers.jsonBody(addressData)
                    },
                    callback: callback
                });
            },
            setAsDefault: function(addressId, callback){
                APIHelpers.sendApiRequest({
                    url: shopApiEndpoint + '/user/address/'+ addressId +'/default',
                    requestOptions: {
                        method: 'POST'
                    },
                    callback: callback
                });
            },
            deleteAddress: function(addressId, callback) {
                APIHelpers.sendApiRequest({
                    url: shopApiEndpoint + '/user/address/' + addressId,
                    requestOptions: {
                        method: 'DELETE'
                    },
                    callback: callback
                });
            }
        },

        // ==================== Qawafil.customer.account ===============================================
        account: {

            updateProfile: function(profileData, callback) {
                APIHelpers.sendApiRequest({
                    url: shopApiEndpoint + '/user/update',
                    requestOptions: {
                        method: 'POST',
                        body: profileData
                    },
                    callback: callback,
                    sendAsFormData: true
                });
            },

            // changePhoneNumber: function(phoneNumber, callback) {
            //     APIHelpers.sendApiRequest({
            //         url: shopApiEndpoint + '/user/change-phone',
            //         requestOptions: {
            //             method: 'POST',
            //             body: APIHelpers.jsonBody({
            //                 mobile: phoneNumber
            //             })
            //         },
            //         callback: callback
            //     });
            // },
            //
            // deleteAccount: function(callback){
            //     APIHelpers.sendApiRequest({
            //         url: shopApiEndpoint + '/user/delete?delete=true',
            //         requestOptions: {
            //             method: 'DELETE'
            //         },
            //         callback: callback
            //     });
            // }

        },


        // ==================== Qawafil.customer.wishlist ===============================================
        wishlist: {
            // "add item to" or "remove item from" customer wishlist
            toggleWishlist: function(productId, callback) {
                APIHelpers.sendApiRequest({
                    url: shopApiEndpoint + '/user/wishlist',
                    requestOptions: {
                        method: 'POST',
                        body: APIHelpers.jsonBody({
                            product_id: productId
                        })
                    },
                    callback: callback
                });
            }
        },

        notitications: {

            getLastNotifications: function(callback) {
                APIHelpers.sendApiRequest({
                    url: shopApiEndpoint + '/user/notifications/last',
                    requestOptions: {
                        method: 'GET',
                    },
                    callback: callback
                });
            },
            deleteAllNotifications: function(callback) {
                APIHelpers.sendApiRequest({
                    url: shopApiEndpoint + '/user/notifications/delete-all',
                    requestOptions: {
                        method: 'DELETE'
                    },
                    callback: callback
                });
            }

        },

        settings: {
            // changeLocale: function(locale, callback) {
            //     APIHelpers.sendApiRequest({
            //         url: shopApiEndpoint + '/user/change-locale/' + locale,
            //         requestOptions: {
            //             method: 'POST'
            //         },
            //         callback: callback,
            //         showResponseMsg: false
            //     });
            // },
            changeLocale: function(locale, callback) {
                // this function change locale in the session + check auth user via access token if exist change his language
                let body = {
                    access_token: localStorage.getItem('access_token') || null
                };
                fetch(shopEndpoint + '/change/store-locale/' + locale, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': Qawafil.auth_helpers.getAuthSessionToken()
                    },
                    body: APIHelpers.jsonBody(body)
                })
                    .then(response => response.json())
                    .then(response => {
                        if (typeof callback === 'function') {
                            callback(response);
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                    });
            }
        }

    };

    var product = {

        /**
         * WS-PRV P4 — one page of the shown comments of a product (GET; public).
         * params: {type: 'review'|'inquiry', sort: 'newest'|'highest'|'lowest', stars: 1-5, page, render: 1 (the page
         * rendered with the store's comment card, `list_html`), exclude_mine: 1 (a review page without the signed-in
         * customer's own review)}. Empty values are not sent.
         */
        getComments: function(productId, params, callback){
            var query = Object.keys(params || {})
                .filter(function (key) { return params[key] !== null && params[key] !== undefined && params[key] !== ''; })
                .map(function (key) { return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]); })
                .join('&');
            APIHelpers.sendApiRequest({
                url: shopApiEndpoint + '/products/' + encodeURIComponent(productId) + '/comments' + (query ? '?' + query : ''),
                requestOptions: {
                    method: 'GET'
                },
                callback: callback
            });
        },
        addComment: function(commentData, callback){
            APIHelpers.sendApiRequest({
                url: shopApiEndpoint + '/products/comments',
                requestOptions: {
                    method: 'POST',
                    body: APIHelpers.jsonBody(commentData)
                },
                callback: callback
            });
        },
        bookingPricing: function(formData,productId, callback){
            APIHelpers.sendApiRequest({
                url: shopApiEndpoint + `/products/${productId}/booking/pricing`,
                requestOptions: {
                    method: 'POST',
                    body: APIHelpers.jsonBody(formData)
                },
                callback: callback
            });
        },
        initializeOrder: function(formData,productId, callback){
            APIHelpers.sendApiRequest({
                url: shopApiEndpoint + `/products/${productId}/order/init`,
                requestOptions: {
                    method: 'POST',
                    body: APIHelpers.jsonBody(formData)
                },
                callback: callback
            });
        },


    };

    var contact = {

        submit: function(contactData, callback){
            APIHelpers.sendApiRequest({
                url: shopApiEndpoint + '/contact-us/store',
                requestOptions: {
                    method: 'POST',
                    body: APIHelpers.jsonBody(contactData)
                },
                callback: callback
            });
        }
    };


    function init(configObj) {
        // 1- set config if given
        config = configObj; // todo: need to be improved and allow setting and getting specific values

        // 3-
        // registerGeneralEvents();
        // registerAddressesEvents();
        // registerCustomerAccountEvents();
        // registerProductEvents();
    }

    return {
        getShopUrl:getShopUrl,
        setShopUrl: setShopUrl,
        setIsRtl: LocalizationHelpers.setIsRtl,
        isRtl: LocalizationHelpers.isRtl,
        // hasAuthSession: hasAuthSession,
        APIHelpers: APIHelpers,
        cart: cart,
        customer: customer,
        auth: auth.publicFunctions,
        auth_helpers: AuthHelpers,
        localization: LocalizationHelpers,
        events: events.publicFunctions,
        product: product,
        contact: contact,
        config: config,
        init: init
    };

})();
